export default __webpack_public_path__ + "static/media/mastercard.c655203c.svg";